import Text from 'src/components/atoms/Text/Text'
import * as Styles from './List.style'
import RichText from 'src/components/atoms/RichText/RichText'
import Padder from 'src/components/_layout/Padder/Padder'
import Container from 'src/components/_layout/Container/Container'
type ListProps = {
    title: string
    items: { item: string }[]
}

const List: React.FC<ListProps> = ({ title, items }) => {
    return (
        <Styles.Wrapper as={Container} small>
            <Padder top="md">
                <Text textVariant="titleMediumSmall">{title}</Text>
                <Padder top="xs" as="ol">
                    {items.map(({ item }, j) => (
                        <Text as="li" key={j} textVariant="title">
                            {item}
                        </Text>
                    ))}
                </Padder>
            </Padder>
        </Styles.Wrapper>
    )
}

export default List
